import { DrawerContainer, DrawerContent } from '@/components/ui/drawer';
import { Header } from '@/components/ui/header';

export type Drawer404Props = {
    onBack?: () => void;
    onClose?: () => void;
};

export const Drawer404 = ({ onBack, onClose }: Drawer404Props) => {
    return (
        <DrawerContainer>
            <div className="flex flex-col gap-3 bg-white px-5 pt-3 border-b border-neutral-200 h-full">
                <Header className="border-b-0" onBack={onBack} onClose={onClose} />
                <DrawerContent>
                    <div className="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8">
                        <p className="text-lg font-semibold leading-8 text-indigo-600">404</p>
                        <h1 className="mt-4 text-3xl font-bold tracking-tight text-neutral-900 sm:text-5xl">
                            Content not found
                        </h1>
                        <p className="mt-6 text-lg leading-7 text-neutral-600">
                            Sorry, we couldn’t find the content you’re looking for.
                        </p>
                    </div>
                </DrawerContent>
            </div>
        </DrawerContainer>
    );
};
